<template>
  <div class="mt-4 lg:mt-10 lg:max-w-4xl">
    <HeaderMessage type="warning" class="lg:text-18 mb-5 lg:mb-7">
      <p v-html="$t('new_provider_email.poor_results', { count: resultsCount })" />
    </HeaderMessage>
    <NewProviderAlertCard
      v-if="!IS_MOBILE_APP"
      case="POOR_RESULTS"
      class="mb-7 lg:mb-14"
      :comparison-id="comparisonId"
      :current-tab="currentTab"
    />
  </div>
</template>

<script lang="ts" setup>
import type { PaymentType } from '@core/types/imt'
import HeaderMessage from './header-message.vue'
import NewProviderAlertCard from './new-provider-alert-card.vue'

const IS_MOBILE_APP = __IS_MOBILE_APP__

withDefaults(
  defineProps<{
    resultsCount: number
    comparisonId: string | null
    currentTab: PaymentType
  }>(),
  { comparisonId: null },
)
</script>
